<template>

  <header class="flex flex-col items-center justify-center h-screen bg-cover bg-center bg-no-repeat"  :style="{ backgroundImage: 'url(' + require(`@/assets/background.png`) + ')' }">
    <div class="flex flex-col items-center max-h-full gap-7">
      <img class="w-full max-h-full object-contain mt-10 md:mt-20" src="@/assets/logo.png" style="max-height: 70%;"  />
      
      <div class="flex flex-row gap-4">
        <button @click="scrollToForm" class="px-5 py-2 mt-3 bg-red-800  text-white text-lg font-semibold hover:bg-gray-500 rounded" >
          <i class="pi pi-check mr-2"></i>ACREDITARME
        </button>
        <router-link to="/credenciales" class="px-5 py-2 mt-3 bg-red-800  text-white text-lg font-semibold hover:bg-gray-500 rounded" >
          <i class="pi pi-check mr-2"></i>YA ME ACREDITÉ
        </router-link>

      </div>

    </div>
  </header>


</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },  
}

</script>